"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * @phrospr/backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.6.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.parsePlanningItemDeliveryAddressChangeResult = exports.PlanningItemDeliveryAddressChangeResultOutlookEventEnum = void 0;
const iplanning_item_entity_1 = require("./iplanning-item-entity");
const movetex_sync_response_1 = require("./movetex-sync-response");
const planning_item_delivery_address_change_result_client_address_1 = require("./planning-item-delivery-address-change-result-client-address");
/**
    * @export
    * @enum {string}
    */
var PlanningItemDeliveryAddressChangeResultOutlookEventEnum;
(function (PlanningItemDeliveryAddressChangeResultOutlookEventEnum) {
    PlanningItemDeliveryAddressChangeResultOutlookEventEnum["Queued"] = "queued";
})(PlanningItemDeliveryAddressChangeResultOutlookEventEnum || (exports.PlanningItemDeliveryAddressChangeResultOutlookEventEnum = PlanningItemDeliveryAddressChangeResultOutlookEventEnum = {}));
function parsePlanningItemDeliveryAddressChangeResult(data) {
    if (data.planning_item !== null && typeof data.planning_item === 'object')
        data.planning_item = (0, iplanning_item_entity_1.parseIPlanningItemEntity)(data.planning_item);
    if (data.client_address !== null && typeof data.client_address === 'object')
        data.client_address = (0, planning_item_delivery_address_change_result_client_address_1.parsePlanningItemDeliveryAddressChangeResultClientAddress)(data.client_address);
    if (data.movetex !== null && typeof data.movetex === 'object')
        data.movetex = (0, movetex_sync_response_1.parseMovetexSyncResponse)(data.movetex);
    return data;
}
exports.parsePlanningItemDeliveryAddressChangeResult = parsePlanningItemDeliveryAddressChangeResult;
